import React from 'react';
import Media from 'react-media';

import { IconRegularClose, theme } from '@notino/react-styleguide-v20';

import { TextButton, ETextDecoration } from '@sharedComponents/Buttons';
import { ReactFCV } from '@types';

import { ISizeProps } from '../model';
import { TextButtonCol } from '../styled';

export interface IButtonProps extends ISizeProps {
  buttonTextContextHelp?: string;
  buttonText: string;
  deleteButtonClick?: () => void;
}

export const Button: ReactFCV<IButtonProps> = ({ deleteButtonClick, buttonTextContextHelp, buttonText, ...rest }) => (
  <TextButtonCol xs={1} sm={1} {...rest}>
    <TextButton
      data-testid="text-button"
      contextHelpText={buttonTextContextHelp}
      onClickAction={deleteButtonClick || (() => {})}
      textDecoration={ETextDecoration.UNDERLINE}
      disabled={false}
      hasHover={true}
      withDebounce={true}>
      <Media query={`(max-width: ${theme.breakpoints.sm ?? ''}rem)`}>
        {(matches) => (matches ? <IconRegularClose color={'icon.tertiary'} width="14px" height="14px" /> : buttonText)}
      </Media>
    </TextButton>
  </TextButtonCol>
);
Button.displayName = 'GeneralProductItem.Button';
